import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const MyNotifications = ({match}) => (
  <div className="app-wrapper">
    <Switch>
 
      <Route path={`${match.url}/bookings`} component={asyncComponent(() => import('./routes/bookings/index'))}/>
      <Route path={`${match.url}/DailyDiary`} component={asyncComponent(() => import('./routes/dailydiary/index'))}/>
       <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default MyNotifications;